var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 35,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E90D7",
    d: "m30.73 1.9-10.5 3.64a.79.79 0 0 0-.25 1.35l2.96 2.5-2.34 2.7a11.75 11.75 0 0 0-5.62-1.9c-3.12-.23-6.15.76-8.52 2.78a11.43 11.43 0 0 0-4.02 7.92 11.64 11.64 0 0 0 11.7 12.42c6.08 0 11.24-4.66 11.69-10.74.22-3.03-.75-5.98-2.74-8.3l2.37-2.74 2.96 2.5a.8.8 0 0 0 1.3-.44L31.79 2.8a.8.8 0 0 0-1.05-.9Zm-8.22 20.44A8.37 8.37 0 0 1 13.52 30a8.33 8.33 0 0 1-7.76-8.87 8.37 8.37 0 0 1 8.99-7.67 8.38 8.38 0 0 1 5.75 2.84 8.16 8.16 0 0 1 2.01 6.03Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#280D44",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M30.68.97 19.77 4.8c-.6.21-.76 1-.27 1.42l3.08 2.64-2.43 2.84a12.17 12.17 0 0 0-14.71.94 12.21 12.21 0 0 0 7.1 21.4c.3.02.59.04.88.04 6.33 0 11.7-4.91 12.17-11.32.23-3.2-.78-6.31-2.85-8.76l2.47-2.88 3.08 2.64a.83.83 0 0 0 1.36-.48L31.8 1.92a.83.83 0 0 0-1.1-.94V.97ZM22.13 22.5a8.74 8.74 0 1 1-17.44-1.29 8.74 8.74 0 0 1 17.44 1.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.9889413bae92fc60e4f633a117d3c0dd.svg";
export { ForwardRef as ReactComponent };